import URL from '@/api/URL';
import fetch from '@/api/fetch';

export function getDataModelList (params) {
  return fetch.post(URL.getDataModelList, params);
}

export function publishApply (params) {
  return fetch.post(URL.publishApply, params);
}

export function publishApplyToEmall (params) {
  return fetch.post(URL.publishApplyToEmall, params);
}

export function getDataModelDetail (params) {
  return fetch.post(URL.getDataModelDetail, params);
}
export function updateAuthority (params) {
  return fetch.post(URL.updateAuthority, params);
}

export function getCompanyTypeList (params) {
  return fetch.post(URL.getCompanyTypeList, params);
}

export function addOrEditCompanyType (params) {
  return fetch.post(URL.addOrEditCompanyType, params);
}

export function delOrgType (params) {
  return fetch.post(URL.delOrgType, params);
}

export function obtainOrgTypeById (params) {
  return fetch.post(URL.obtainOrgTypeById, params);
}

export function obtainOrgTypeNamesList (params) {
  return fetch.post(URL.obtainOrgTypeNamesList, params);
}

export function getClassList (params) {
  return fetch.post(URL.getClassList, params);
}

export function addClassItem (params) {
  return fetch.post(URL.addClassItem, params);
}

export function obtainDictionariesByKeyword (params) {
  return fetch.post(URL.obtainDictionariesByKeyword, params);
}



// WEBPACK FOOTER //
// ./src/api/modules/dataModelMall.js